<script setup lang="ts">
import { onMounted, watch, computed } from 'vue'
import { ConfigGlobal } from '@/components/ConfigGlobal'
import WaterMark from '@/components/WaterMark/index.vue'
import { useUserStore } from '@/store/modules/user'
import { useAppStore } from '@/store/modules/app'

import { useRouter } from 'vue-router'

import { getAccountInfo, getVersionConfig } from '@/api'
import { useLocaleStore } from '@/store/modules/locale'
import { useLocale } from '@/hooks/web/useLocale'
const localeStore = useLocaleStore()

const router = useRouter()

interface WMConfig {
  content: string
  invisibleContent: string
  invisibleFontSize: [number, string]
  font: object
  zIndex: [number, string]
  rotate: number
  visibleWmDensityLevel: number
  gap: [number, number]
  invisibleWmDensityLevel: number
  offset: [number, number]
}

const userStore = useUserStore()
const appStore = useAppStore()

const config: WMConfig = computed(() => {
  return userStore.getWaterMark
})

const islogin = ref(false)

watch(
  () => router.currentRoute.value,
  () => {
    islogin.value = router.currentRoute.value.name === 'Login'
  }
)

// const islogin = ref(false)

onMounted(() => {
  // islogin.value = window.location.href.indexOf('login') !== -1
  getVersionConfig()
  if (userStore.getUserInfo?.accountCode) {
    getAccountInfo({
      // accountCode: userStore.getUserInfo?.accountCode
    }).then((res) => {
      // window.location.reload()
      localeStore.setCurrentLocale({
        lang: res.data.language
      })
      const { changeLocale } = useLocale()
      changeLocale(res.data.language)
      // 刷新查询info再次设置userInfo
      const info = {
        accountCode: res.data?.accountCode,
        username: res.data?.name,
        telNumber: res.data?.telNumber,
        organizationPermission: res.data?.organizationPermission
      }
      userStore.setUserInfo(info)
    })
    // 获取指标字典
    appStore.fetchNounDictionary()
  }
})

// 水印自定义数据转换
const wmOriginData = computed(() => {
  if (!config.value?.content.trim() || !config.value?.originData?.otherContent) {
    return null
  }
  return {
    otherContent: config.value.originData.otherContent,
    smallDatetime: config.value.originData.smallDatetime,
    fontSize: config.value.originData.visibleWmFontSize + 'px',
    color: `rgba(${config.value.originData.visibleWmColor.red}, ${config.value.originData.visibleWmColor.green}, ${config.value.originData.visibleWmColor.blue}, ${config.value.originData.visibleWmColor.alpha / 100})`
  }
})

const isSafari = () => {
  var userAgent = navigator.userAgent.toLowerCase()
  return userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1
}

const isSafari_ = isSafari()

const monitorEnv = import.meta.env.VITE_WEBFUNNY_MONITOR_ENV
const version = import.meta.env.VITE_APP_VERSION

watch(
  () => userStore.userInfo?.accountCode,
  (newVal, oldVal) => {
    if (newVal != oldVal) {
      window.localStorage.wmUserInfo = JSON.stringify({
        userId: newVal || '',
        userTag: monitorEnv,
        projectVersion: version,
        env: monitorEnv
      })
    }
  },
  {
    immediate: true
  }
)
</script>

<template>
  <ConfigGlobal>
    <WaterMark
      :content="isSafari_ ? config.content : ''"
      :font="config.font"
      :rotate="config.rotate"
      :wmLevel="config.visibleWmDensityLevel"
      :gap="config.gap"
      :useSlot="isSafari_ ? false : true"
      :offset="config.offset"
    >
      <template #custom>
        <div
          v-if="wmOriginData"
          class="wm_dom"
          :style="{
            fontSize: wmOriginData.fontSize,
            color: wmOriginData.color
          }"
        >
          {{ wmOriginData.otherContent }}<span>{{ wmOriginData.smallDatetime }}</span>
        </div>
      </template>
      <WaterMark
        :wmLevel="config.invisibleWmDensityLevel"
        :offset="[0, -75]"
        :rotate="config.rotate"
        :content="config.invisibleContent"
        :font="{
          fontSize: config.invisibleFontSize,
          color: 'rgba(240,96,111, 0.005)'
        }"
      >
        <!-- <RouterView v-show="config.content || config.isClose || islogin" /> -->
        <RouterView />
      </WaterMark>
    </WaterMark>
  </ConfigGlobal>
</template>

<style lang="scss">
.size {
  width: 100%;
  height: 100%;
}

html,
body {
  min-width: 1440px;
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  overflow-x: auto;
  @extend .size;

  #app {
    font-size: var(--el-font-size-base);
    color: var(--el-text-color-regular);
    @extend .size;
  }
}

.wm_dom {
  width: 150px;
  height: 30px;
  background-color: transparent;
  font-size: 16px;
  line-height: 30px;
  // background: #666;
  span {
    font-size: 11px;
    margin-left: 8px;
  }
}
</style>
